module.exports = __webpack_public_path__ + "static/SentiLink-49bce7a21e7a27a712b62f84eec02fd1.jpg";